var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpotify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4998 21C34.2079 21 21 34.2078 21 50.5002C21 66.7932 34.2079 80 50.4998 80C66.7935 80 80 66.7932 80 50.5002C80 34.2089 66.7935 21.0014 50.4995 21.0014L50.4998 21ZM64.0283 63.5477C63.4999 64.4143 62.3656 64.6891 61.499 64.1572C54.5727 59.9263 45.8534 58.9682 35.5849 61.3143C34.5954 61.5398 33.609 60.9198 33.3836 59.9299C33.1571 58.94 33.7746 57.9536 34.7666 57.7281C46.0039 55.1608 55.6429 56.2662 63.4188 61.0184C64.2854 61.5503 64.5602 62.6811 64.0283 63.5477ZM67.639 55.5152C66.9732 56.5973 65.5571 56.939 64.4756 56.2733C56.5461 51.3992 44.4588 49.9876 35.0797 52.8347C33.8634 53.2021 32.5786 52.5166 32.2095 51.3023C31.8431 50.0859 32.529 48.8036 33.7432 48.4337C44.4567 45.1829 57.7755 46.7576 66.8816 52.3535C67.9631 53.0193 68.3048 54.4351 67.639 55.5152ZM67.949 47.1508C58.4413 41.5034 42.7549 40.9842 33.6774 43.7393C32.2197 44.1814 30.6782 43.3585 30.2364 41.9008C29.7947 40.4424 30.6169 38.9019 32.0756 38.4587C42.496 35.2953 59.8187 35.9065 70.765 42.4049C72.0789 43.1831 72.5087 44.8765 71.7302 46.1859C70.9552 47.497 69.2573 47.9293 67.9504 47.1508H67.949Z",
    fill: "#1ED760"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.72a412980a6baf0c9840ea3b49eb0331.svg";
export { ForwardRef as ReactComponent };